<template>
  <div class="features">
    <v-layout row justify-center>
      <h2>{{ $t('titels.features') }}</h2>
      <p class="long-copy"></p>
    </v-layout>
    <div data-aos="fade-up" data-aos-offset="50" data-aos-duration="1500">
      <v-layout row wrap justify-center>
        <v-flex class="ml-10 mt-5" md8 lg2 xs8 sm8>
          <v-img class="icon" src="../assets/bird_logo.png"></v-img>
          <h3>{{ $t('titels.birds') }}</h3>
          <p>{{ $t('features.birds') }}</p>
          <router-link class="btn btn-full" :to="`/${$i18n.locale}/birds`">{{ $t('titels.birds') }}</router-link>
        </v-flex>
        <v-flex class="ml-10 mt-5" md8 lg2 xs8 sm8>
          <v-img class="icon" src="../assets/26103.png"></v-img>
          <h3>{{ $t('titels.mammal') }}</h3>
          <p>{{ $t('features.mammal') }}</p>
          <router-link
            class="btn btn-ghost"
            :to="`/${$i18n.locale}/mammal`"
          >{{ $t('titels.mammal') }}</router-link>
        </v-flex>
        <v-flex class="ml-10 mt-5" md8 lg2 xs8 sm8>
          <v-img class="icon" src="../assets/recent_logo.png"></v-img>
          <h3>{{ $t('titels.recent') }}</h3>
          <p>{{ $t('features.recent') }}</p>
          <router-link class="btn btn-ghost" :to="`/${$i18n.locale}/recent`">{{ $t('titels.recent') }}</router-link>
        </v-flex>
        <v-flex class="ml-10 mt-5" md8 lg2 xs8 sm8>
          <v-img class="icon" src="../assets/world.png"></v-img>
          <h3>{{ $t('titels.travel') }}</h3>
          <p>{{ $t('features.travel') }}</p>
          <router-link
            class="btn btn-ghost"
            :to="`/${$i18n.locale}/travel`"
          >{{ $t('titels.travel') }}</router-link>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: "Features"
};
</script>

<style>
.features p {
  font-size: 90%;
  line-height: 145%;
  text-align: justify;
}

.icon {
  width: 20%;
}
</style>